import { Component, OnInit } from '@angular/core';

 import {session} from '../../../../environments/environment.session'
  @Component({
  selector: '[app-hrms-footer]',
  templateUrl: './hrms-footer.component.html',
  styleUrls: ['./hrms-footer.component.css']
})
export class HrmsFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
